import formatCount from '@UI/Pages/Home/Helpers/formatCount';

/** Figure shown under a dossier type: "Aucun dossier", "1 dossier" or "n dossiers". */
const describeSubjectCount = (count: number): string => {
	if (count === 0) {
		return 'Aucun dossier';
	}

	if (count === 1) {
		return '1 dossier';
	}

	return `${formatCount(count)} dossiers`;
};

export default describeSubjectCount;
